import { render, staticRenderFns } from "./RiskPdfBasis.vue?vue&type=template&id=19d6f56c&scoped=true&"
import script from "./RiskPdfBasis.vue?vue&type=script&lang=js&"
export * from "./RiskPdfBasis.vue?vue&type=script&lang=js&"
import style0 from "./RiskPdfBasis.vue?vue&type=style&index=0&id=19d6f56c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6f56c",
  null
  
)

export default component.exports